import PropTypes from 'prop-types';
import React from 'react';
import FeedArticle from '../FeedArticle';
import articlePropType from '../../propTypes/article';

const PromoCards = ({ promoBoxCards, feedLocale }) => (
  <div className="sl-promobox-cards">
    {promoBoxCards.map((article, index) => (
      <FeedArticle
        article={article}
        key={article.id}
        type="promo"
        promoPosition={index + 7}
        feedLocale={feedLocale}
      />
    ))}
  </div>
);

PromoCards.propTypes = {
  promoBoxCards: PropTypes.arrayOf(articlePropType).isRequired,
  feedLocale: PropTypes.string,
};

PromoCards.defaultProps = {
  feedLocale: null,
};

export default PromoCards;
